export const SET_MAP_SWITCHER_STATE = '@mapSwitcher/SET_MAP_SWITCHER_STATE';
//# sourceMappingURL=constants.js.map